define("settings/templates/subscription", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.isPageRestricted}}
    <RestrictedPage @description={{t "account.restricted_page.subscription_title" email=this.accountOwnerEmail}} />
  {{else}}
    <MigrationBanner />
  
    {{outlet}}
  {{/if}}
  */
  {
    "id": "dKeKL9lW",
    "block": "[[[41,[30,0,[\"isPageRestricted\"]],[[[1,\"  \"],[8,[39,1],null,[[\"@description\"],[[28,[37,2],[\"account.restricted_page.subscription_title\"],[[\"email\"],[[30,0,[\"accountOwnerEmail\"]]]]]]],null],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,3],null,null,null],[1,\"\\n\\n  \"],[46,[28,[37,5],null,null],null,null,null],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"restricted-page\",\"t\",\"migration-banner\",\"component\",\"-outlet\"]]",
    "moduleName": "settings/templates/subscription.hbs",
    "isStrictMode": false
  });
});